__webpack_require__.p = "/otclient-font-create-tool/";